import { createRoutine } from 'redux-saga-routines'

export const SET = 'POSTULAR/SET'
export const CONTENT = createRoutine('POSTULAR/CONTENT')
export const HOME_CONTENT = createRoutine('POSTULAR/HOME_CONTENT')
export const INVITE_FORM_CONTENT = createRoutine('POSTULAR/INVITE_FORM_CONTENT')
export const SUBMIT_PROTAGONISTA_SUGGESTION = createRoutine('POSTULAR/SUBMIT_PROTAGONISTA_SUGGESTION')
